import React, { useState, useContext } from 'react';
import { Row, Col, Container } from 'reactstrap';
import styles from './GetStartedToday.module.css';
import classNames from 'classnames';
import { SessionContext } from '../../context/SessionContext';
import EnrollmentModal from '../../components/Modals/Enrollment/Enrollment';
import ProtectionBanner from '../../assets/images/Vendor/MCC/MCC_Benefit.jpeg';

const GetStartedTodayMCC = () => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;
    const [showEnrollmentModal, setShowEnrollmentModal] = useState(false);

    const handleShowActionModal = () => {
        setShowEnrollmentModal(true);
    };

    return (
        <Row className={styles.getStartedContentContainer}>
            <Col
                lg='7'
                md='7'
                className={classNames('text-start', 'order-2', 'order-md-1', 'order-lg-1', styles.getStartedInfo)}
            >
                <h1 className={styles.getStartedHeader}>Your Customers will Thank You</h1>
                <div className={styles.getProtectionContainer}>
                    <p>
                        An HVAC system is likely one of the most expensive investments in the home. To make a large
                        purchase and then experience a failure is{' '}
                        <span className={styles.textHighlight}>frustrating</span>. Discovering the cost of labor
                        expenses may not be covered under the manufacturer's warranty can add to the
                        <span className={styles.textHighlight}> stressful situation for customers</span>.
                    </p>
                    <p>
                        <b>
                            Help your customers overcome these negative experiences by offering an extended service
                            agreement with every equipment installation.
                        </b>
                    </p>
                </div>
                <button
                    className={classNames(styles.enrollToday)}
                    onClick={(e) => handleShowActionModal()}
                >
                    Become a Dealer
                </button>
            </Col>
            <Col
                lg='5'
                md='5'
                className={classNames(styles.protectionBannerContainer, 'order-1 order-md-2 order-lg-2')}
            >
                <img
                    src={ProtectionBanner}
                    className={styles.protectionBanner}
                    alt='MCC landing icon'
                />
            </Col>
            {showEnrollmentModal && (
                <EnrollmentModal
                    isOpen={showEnrollmentModal}
                    centered={true}
                    toggle={() => setShowEnrollmentModal(!showEnrollmentModal)}
                    accountName={accountName}
                />
            )}
        </Row>
    );
};

export default GetStartedTodayMCC;
